/*
Front-end User script
 */
jQuery(document).ready(function ($) {
	var Up2Cookie = Cookies.noConflict(),
		$body = $('body'),
		$button = $('.request-check-details'),
		result = $('#result-message');

	if ('1' !== Up2Cookie.get('up2_request_check_details_' + $button.data('check-id'))) {
		$button.prop('disabled', false).removeClass('disabled');
	} else {
		result.html(up2.check_request.messages.requested);
	}

	$body.on('click', '.request-check-details', function (e) {
		e.preventDefault();

		var $this = $(this),
			checkId = $this.data('check-id');

		result.html(getSpinner());

		$this.prop('disabled', true).addClass('disabled');

		$.ajax({
			method: 'POST',
			url: up2.ajax_url,
			data: {
				check_id: checkId,
				action: 'request_periodic_inspection_details',
				_ajax_nonce: $this.data('nonce')
			},
			dataType: 'json'
		}).done(function (response) {
			result.html(response.message);

			if (response.sent) {
				Up2Cookie.set('up2_request_check_details_' + checkId, 1);
			}
		}).fail(function () {
			result.html(up2.check_request.messages.error);
		}).always(function () {
			result.find('.lds-spinner').remove();
		});
	});
});

function getSpinner() {
	return '<div class="lds-spinner" style="100%;height:100%"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>';
}